export default "__VITE_ASSET__przY$n1K__"